export default __webpack_public_path__ + "static/christian-023b104f67be37bfc02290978fa95fae.jpg";